export type AppointmentType =
  | 'consultation'
  | 'follow_up'
  | 'antenatal'
  | 'ultrasound'
  | 'procedure'
  | 'emergency';

export type AppointmentStatus =
  | 'scheduled'
  | 'confirmed'
  | 'checked_in'
  | 'completed'
  | 'cancelled'
  | 'no_show';

export type BlockOutType = 'theatre' | 'lunch' | 'leave' | 'meeting' | 'other';

export interface Appointment {
  id: string;
  patientId: string;
  patientName: string;
  doctorId: string;
  date: string;
  startTime: string;
  endTime: string;
  durationMinutes: number;
  appointmentType: AppointmentType;
  status: AppointmentStatus;
  notes: string;
  isBlockOut: boolean;
  blockType?: BlockOutType;
  cancellationReason?: string;
  cancelledAt?: string;
  cancelledBy?: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export const APPOINTMENT_TYPE_LABELS: Record<AppointmentType, string> = {
  consultation: 'Consultation',
  follow_up: 'Follow-up',
  antenatal: 'Antenatal',
  ultrasound: 'Ultrasound',
  procedure: 'Procedure',
  emergency: 'Emergency',
};

export const APPOINTMENT_TYPE_COLORS: Record<AppointmentType, string> = {
  consultation: 'bg-blue-100 text-blue-800 border-blue-300',
  follow_up: 'bg-green-100 text-green-800 border-green-300',
  antenatal: 'bg-pink-100 text-pink-800 border-pink-300',
  ultrasound: 'bg-purple-100 text-purple-800 border-purple-300',
  procedure: 'bg-orange-100 text-orange-800 border-orange-300',
  emergency: 'bg-red-100 text-red-800 border-red-300',
};

export const BLOCK_TYPE_LABELS: Record<BlockOutType, string> = {
  theatre: 'Theatre',
  lunch: 'Lunch',
  leave: 'Leave',
  meeting: 'Meeting',
  other: 'Other',
};

export const STATUS_COLORS: Record<AppointmentStatus, string> = {
  scheduled: 'bg-blue-50 text-blue-700',
  confirmed: 'bg-green-50 text-green-700',
  checked_in: 'bg-yellow-50 text-yellow-700',
  completed: 'bg-gray-100 text-gray-600',
  cancelled: 'bg-red-50 text-red-600 line-through',
  no_show: 'bg-orange-50 text-orange-700',
};
